module.exports = __webpack_public_path__ + "static/media/zu Informationszwecken.9a934ec7.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/zu Informationszwecken.docx
// module id = 1519
// module chunks = 0